<script setup lang="ts">
import CountUp from '@/components/CountUp.vue'
import { useResume } from '@/composables/useResume'

const { content } = useResume()
</script>

<template>
  <div class="wrap">
    <div class="stats">
      <div v-for="(stat, i) in content.stats" :key="i" class="stat glass reveal" :class="`d${i + 1}`">
        <div class="v grad-text"><CountUp :value="stat.value" /></div>
        <div class="l">{{ stat.label }}</div>
      </div>
    </div>
  </div>
</template>
